// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "c8641d1692f13d551f9e" + ".js";
};